const VOICE_TITLE_SUFFIX = "AI Voice Generator [Make Songs!]| Musicfy LOL";

/**
 * SERP / social title for public voice generator pages.
 * Character name leads; brand trails for CTR differentiation.
 */
export function buildVoicePageTitle(characterName: string): string {
  const name = characterName.trim();
  if (!name) {
    return VOICE_TITLE_SUFFIX;
  }
  return `${name} ${VOICE_TITLE_SUFFIX}`;
}

/** Last path segment of a voice URL, without query string. */
export function getVoiceCharacterNameFromPath(asPath: string): string {
  const pathOnly = asPath.split("?")[0] ?? asPath;
  const segments = pathOnly.split("/").filter(Boolean);
  const lastSegment = segments[segments.length - 1] ?? "";
  if (!lastSegment || lastSegment === "voice") {
    return "";
  }
  try {
    return decodeURIComponent(lastSegment);
  } catch {
    return lastSegment;
  }
}
